/**
 * The client card's `⋯` — which entries stand above „Zakończ współpracę", and in what order.
 *
 * „Przypisz ankietę" (8 October 2026) is offered only once the header read has answered: its dialog
 * is built for a NAMED client and mounted on that answer, so an entry drawn before it would be a
 * press that opens nothing. „Ustawienia rozliczeń" needs only the id and stands from the first frame.
 */

export type CardMenuEntry = 'assignSurvey' | 'selfBooking';

export function cardMenuEntries(identityAnswered: boolean): readonly CardMenuEntry[] {
  return identityAnswered ? ['assignSurvey', 'selfBooking'] : ['selfBooking'];
}
